// Products Catalog
import React from 'react';
import ReactDOM from 'react-dom';
import { ProductCatalog } from './apps';

const App = () => <ProductCatalog />;

ReactDOM.render(<App />, document.getElementById('app-product-catalog'));
